import React from 'react'
import { Text } from '@mantine/core'
import { getLevelDesc, getLevelStr } from '../ReportUtils'
import { useTheme } from '../../../components/ThemeProvider'

interface ReportScoreProps {
  data: any
}

export default function ReportScore({ data }: ReportScoreProps) {
  const theme = useTheme()
  const focusCount = (data?.meta_index_focus_details ?? data?.meta_index_focus_list ?? []).length
  const moduleCount = (data?.meta_data_module_list ?? []).length
  const highlightColor = theme.primaryColor

  return (
    <div className="flex flex-col gap-6 md:flex-row">
      <div
        className="rounded-lg border px-6 py-5 md:max-w-[240px]"
        style={{ backgroundColor: theme.surfaceEmphasisColor, borderColor: theme.surfaceBorderColor }}
      >
        <Text size="xs" fw={600} style={{ letterSpacing: '0.12em', color: theme.accentTextColor }}>
          风险评分
        </Text>
        <Text
          style={{
            marginTop: '12px',
            fontSize: '48px',
            fontWeight: 700,
            lineHeight: 1,
            color: highlightColor,
          }}
        >
          {data?.meta_index_score || '--'}
        </Text>
        <Text size="sm" fw={600} style={{ marginTop: '8px', color: highlightColor }}>
          {getLevelStr(data)}
        </Text>
      </div>
      <div className="flex flex-1 flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            评分说明
          </Text>
          <Text size="sm" className="text-gray-600">
            {getLevelDesc(data)}
          </Text>
        </div>
        <div className="flex flex-wrap gap-4">
          <SummaryItem label="关注模块" value={`${focusCount} 项`} highlight={focusCount > 0} color={highlightColor} />
          <SummaryItem label="覆盖模块" value={`${moduleCount} 项`} />
        </div>
      </div>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  highlight?: boolean
  color?: string
}

function SummaryItem({ label, value, highlight = false, color }: SummaryItemProps) {
  const theme = useTheme()
  return (
    <div
      className="min-w-[140px] rounded-md border px-4 py-3"
      style={{ backgroundColor: theme.surfaceColor, borderColor: theme.surfaceBorderColor }}
    >
      <Text size="xs" style={{ color: theme.accentTextColor }}>
        {label}
      </Text>
      <Text
        size="sm"
        fw={600}
        className={highlight ? '' : 'text-gray-700'}
        style={{
          marginTop: '6px',
          color: highlight ? color || theme.primaryColor : undefined,
        }}
      >
        {value}
      </Text>
    </div>
  )
}
